




import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Tree from 'tui-tree';

@Component({})
export default class Tuitree extends Vue {
  @Prop({required: true})
  private data!: [];
  private tree: any;
  private options = {
    data: [],
    nodeDefaultState: 'closed',
    template: {
      internalNode: `<div class="tui-tree-content-wrapper ">
                        <button type="button" class="tui-tree-toggle-btn tui-js-tree-toggle-btn ">
                          <span class="tui-ico-tree"></span>
                        </button>
                        <span class="tui-tree-text tui-js-tree-text">
                          {{text}}{{displayIcon}}
                        </span>
                      </div><ul class="tui-tree-subtree tui-js-tree-subtree">{{children}}</ul>`,
      leafNode: `<div class="tui-tree-content-wrapper" style="padding-left: {{indent}}px">
                      <span class="tui-tree-text tui-js-tree-text">
                          {{text}}{{displayIcon}}
                      </span>
                  </div>`
    }
  };
  @Watch('data')
  onDataChanged() {
    if (this.data.length === 0) return;
    if (!this.tree) {
      this.tree = new Tree('#treeRoot', this.options);
    }
    this.tree.resetAllData(this.data);
    this.$nextTick(() => {
      this.tree.select('tui-tree-node-1'); //默认选中第一个
    });
  }
  public addTree(obj: any, targetId?: any): void {
    let template = this.tree.add(obj, targetId);
    if (targetId) {
      this.tree.open(template, true);
    }
    this.tree.select(template);
  }
  private mounted() {
    this.tree = new Tree('#treeRoot', this.options);
    // this.tree.enableFeature('Draggable', {
    //   helperClassName: 'tui-tree-drop',
    //   lineClassName: 'tui-tree-line',
    //   isSortable: true
    // });
    this.tree.enableFeature('Selectable', {
      selectedClassName: 'tui-tree-selected'
    });
    this.tree.on('select', (eventData: any) => {
      var nodeData = this.tree.getNodeData(eventData.nodeId);
      const depth = this.tree.getDepth(eventData.nodeId);
      const parentId = this.tree.getParentId(eventData.nodeId);
      const parentData = this.tree.getNodeData(parentId);
      this.$emit('changeSelect', {originData: eventData, theObj: nodeData, theIndex: depth, theParentData: parentData});
    });
  }
}
